import { useEffect, useRef } from "react";

export function LeadflowForm() {
  const ref = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.origin !== "https://leadflow.puulse.ai") return;
      if (e.source !== ref.current?.contentWindow) return;
      const d = e.data;
      if (d?.type === "puulse-form-height" && d.height > 0 && ref.current) {
        ref.current.style.height = Math.ceil(d.height) + "px";
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);
  return (
    <iframe
      ref={ref}
      src="https://leadflow.puulse.ai/amr3designconstruction/contact"
      title="Contact form"
      loading="lazy"
      style={{ width: "100%", border: 0, height: 700, background: "transparent" }}
    />
  );
}
